export default __webpack_public_path__ + "static/media/falafhd.212b335b.png";